import { render, staticRenderFns } from "./EditGuardianForm.vue?vue&type=template&id=4d318bb4&"
import script from "./EditGuardianForm.vue?vue&type=script&lang=js&"
export * from "./EditGuardianForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports